




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionSkillStoreEdit from '@/store/modules/cvSectionSkillEdit';
import EditContainer from '@/containers/cv-section-skill/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionSkillStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, id } = params;
  await store.dispatch(
    CvSectionSkillStoreEdit.GetCvSectionSkill.namespaced({
      params: { cv_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionSkillStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionSkill']),
  },
});
